import { BitcoinFaceLogoProps } from "../../store/faces";

const BitcoinFace584 = (props: BitcoinFaceLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 147 147"
    width={props.width}
    height={props.height}
  >
    <g clipPath="url(#prefix__a)">
      <path fill="#FEC233" d="M150.675 0H0v150.675h150.675V0Z" />
      <path fill="#BA3D11" d="M124.803 66.54H23.698v81.168h101.105V66.541Z" />
      <path fill="#542F5F" d="M101.677 66.319H45.483v81.389h56.194V66.319Z" />
      <path fill="#172027" d="M102.165 66.319H73.553v81.389h28.612V66.319Z" />
      <path
        fill="#727FBD"
        d="M74.842 22.594c27.565 0 51.234 22.344 51.234 49.911v34.785H74.239"
      />
      <path
        fill="#AAAECC"
        d="M76.813 22.557H75.49c-27.564 0-49.908 22.346-49.908 49.914v34.819h50.245"
      />
      <path
        fill="#727FBD"
        d="M75.827 126.01h14.582a43.327 43.327 0 0 0 35.662-18.72H75.827v18.72Z"
      />
      <path
        fill="#AAAECC"
        d="M75.827 126.01H61.242a43.32 43.32 0 0 1-35.66-18.72h50.245v18.72ZM29.51 78.173h-.309a15.694 15.694 0 0 1-15.695-15.698v-9.452h39.145l-23.14 25.15Z"
      />
      <path
        fill="#727FBD"
        d="M118.673 78.173h.316a15.696 15.696 0 0 0 15.688-15.698v-9.452h-32.928l16.924 25.15Z"
      />
      <path
        fill="#4D2F47"
        d="M120.96 58.74a8.004 8.004 0 0 1 5.589 13.622 8.005 8.005 0 0 1-5.589 2.382M27.223 74.744a8.003 8.003 0 0 1 0-16.004"
      />
      <path
        fill="#727FBD"
        d="M27.223 73.69a5.19 5.19 0 0 1 0-10.379M120.343 63.311a5.192 5.192 0 0 1 5.103 5.19 5.193 5.193 0 0 1-5.103 5.19"
      />
      <path fill="#FA8CB2" d="M78.161 81.43H46.665V96.25H78.16V81.43Z" />
      <path fill="#EFE1DA" d="M78.162 83.282H50.371v11.116h27.791V83.282Z" />
      <path
        fill="#001A1B"
        d="M55.929 83.282h-1.852v11.116h1.852V83.282ZM61.487 83.282h-1.852v11.116h1.852V83.282ZM67.05 83.276h-1.853v11.116h1.852V83.276ZM72.608 83.276h-1.853v11.116h1.853V83.276Z"
      />
      <path fill="#F46461" d="M73.526 96.256h28.731V81.434h-28.73v14.822Z" />
      <path fill="#EFE1DA" d="M72.599 94.404h25.954V83.288H72.599v11.116Z" />
      <path
        fill="#001A1B"
        d="M92.993 94.404h1.853V83.288h-1.853v11.116ZM87.435 94.404h1.852V83.288h-1.852v11.116ZM81.873 94.398h1.852V83.282h-1.852v11.116ZM76.315 94.398h1.852V83.282h-1.852v11.116Z"
      />
      <path
        fill="#883A62"
        d="M100.418 82.356h-51.93v6.491h51.93v-6.491Z"
        opacity={0.3}
        style={{
          mixBlendMode: "multiply",
        }}
      />
      <path
        stroke="#070707"
        strokeMiterlimit={10}
        strokeWidth={2.707}
        d="M117.328 67.674a18.186 18.186 0 0 1-5.414 12.951 18.194 18.194 0 0 1-13.022 5.242c-9.995-.13-17.953-8.464-17.953-18.463a5.793 5.793 0 0 0-5.793-5.793h-.272"
      />
      <path
        stroke="#070707"
        strokeMiterlimit={10}
        strokeWidth={2.707}
        d="M32.42 67.674a18.194 18.194 0 0 0 18.437 18.193c9.996-.13 17.952-8.464 17.952-18.463a5.794 5.794 0 0 1 5.795-5.793h.27"
      />
      <path
        fill="#8E97C4"
        d="M32.42 67.674H68.81a18.194 18.194 0 0 1-36.388 0ZM80.77 67.507h36.389a18.195 18.195 0 0 1-36.389 0Z"
        opacity={0.57}
        style={{
          mixBlendMode: "color-dodge",
        }}
      />
      <path fill="#FA8CB2" d="M74.433 59.817H61.547v2.864h12.886v-2.864Z" />
      <path
        fill="#4D2F47"
        d="M50.093 74.135c7.117 0 12.886-5.77 12.886-12.886 0-7.117-5.77-12.886-12.886-12.886-7.117 0-12.886 5.77-12.886 12.886 0 7.117 5.77 12.886 12.886 12.886Z"
      />
      <path
        fill="#ED7E29"
        d="M50.093 71.272c5.535 0 10.022-4.488 10.022-10.023 0-5.535-4.487-10.022-10.022-10.022s-10.022 4.487-10.022 10.022 4.487 10.023 10.022 10.023Z"
      />
      <path fill="#001A1B" d="M61.547 59.817H38.64v2.864h22.908v-2.864Z" />
      <path fill="#FA8CB2" d="M74.44 62.685h12.887v-2.863H74.44v2.863Z" />
      <path
        fill="#001A1B"
        d="M98.78 74.14c7.118 0 12.887-5.77 12.887-12.886 0-7.117-5.769-12.886-12.886-12.886-7.117 0-12.886 5.769-12.886 12.886 0 7.117 5.77 12.886 12.886 12.886Z"
      />
      <path
        fill="#ED7E29"
        d="M98.78 71.276c5.536 0 10.023-4.487 10.023-10.022 0-5.536-4.487-10.023-10.022-10.023s-10.023 4.487-10.023 10.023c0 5.535 4.488 10.022 10.023 10.022Z"
      />
      <path fill="#001A1B" d="M87.327 62.685h22.908v-2.863H87.327v2.863Z" />
      <path
        fill="#4A3022"
        d="m73.985 79.198-14.628-8.776a15.876 15.876 0 0 1 14.068 1.128l.56.335"
      />
      <path
        fill="#021213"
        d="m74.051 79.182 14.628-8.778a15.875 15.875 0 0 0-14.07 1.128l-.558.335"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <rect width={147} height={147} fill="#fff" rx={7} />
      </clipPath>
    </defs>
  </svg>
);
export default BitcoinFace584;
